/*
 * Puente con Google Tag Manager (contenedor GTM-53GR9VR7, en index.html).
 *
 * La landing no dispara etiquetas por su cuenta: solo empuja eventos al
 * dataLayer y es GTM quien decide qué hacer con ellos. Nada de lo que pase
 * aquí puede tumbar el flujo del formulario — si el contenedor está bloqueado
 * por un adblocker, el push simplemente se queda en la cola del array.
 */

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

/** Evento personalizado del envío correcto; es el que se configura en GTM. */
export const REGISTRATION_SUCCESS_EVENT = 'vendor_registration_success';

/** Empuja al dataLayer, creándolo si el contenedor aún no ha cargado. */
function push(payload: Record<string, unknown>) {
  try {
    window.dataLayer = window.dataLayer ?? [];
    window.dataLayer.push(payload);
  } catch {
    // La analítica nunca interrumpe el registro.
  }
}

/**
 * Solicitud de comercio enviada y aceptada por la API.
 *
 * Va en un único push para que las variables de contacto lleguen a GTM en el
 * mismo evento que las consume: una etiqueta que escuche
 * `vendor_registration_success` puede leer `name`, `email` y `phone` como
 * variables de capa de datos sin depender del orden de los pushes.
 */
export function trackRegistrationSuccess(contact: {
  name: string;
  email: string;
  /** Ya normalizado a solo dígitos por el formulario. */
  phone: string;
}) {
  push({
    event: REGISTRATION_SUCCESS_EVENT,
    name: contact.name.trim(),
    email: contact.email.trim().toLowerCase(),
    phone: contact.phone,
  });
}
